(function () {
  var formSection = document.getElementById('devis-pc-sur-mesure');
  if (!formSection) return;

  var form = formSection.querySelector('form.lgk-devis-pc-form__form');
  var progress = formSection.querySelector('[data-lgk-devis-progress]');
  var progressBar = formSection.querySelector('[data-lgk-devis-progress-bar]');
  var progressLabel = formSection.querySelector('[data-lgk-devis-progress-label]');
  var sticky = document.querySelector('[data-lgk-devis-sticky]');
  var stickyLabel = document.querySelector('[data-lgk-devis-sticky-label]');
  var stepNav = formSection.querySelector('.lgk-devis-pc-form__steps-nav');
  var groups = form ? form.querySelectorAll('.lgk-devis-pc-form__group[data-devis-group]') : [];

  function groupIsComplete(group) {
    var fields = group.querySelectorAll('input:not([type="hidden"]), select, textarea');
    var hasRequired = false;
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (!field.required) continue;
      hasRequired = true;
      if (field.type === 'checkbox' && !field.checked) return false;
      if (field.tagName === 'SELECT' && !field.value) return false;
      if (!field.value || !String(field.value).trim()) return false;
    }
    return hasRequired;
  }

  function updateProgress() {
    if (!form || !progressBar) return;
    var done = 0;
    groups.forEach(function (group) {
      var complete = groupIsComplete(group);
      group.classList.toggle('is-complete', complete);
      if (complete) done += 1;
    });
    var pct = groups.length ? Math.round((done / groups.length) * 100) : 0;
    progressBar.style.width = pct + '%';
    var label = done + ' / ' + groups.length + ' étapes complétées';
    if (progressLabel) progressLabel.textContent = label;
    if (stickyLabel) stickyLabel.textContent = label;
    if (progress) progress.setAttribute('aria-valuenow', String(pct));
  }

  if (form) {
    form.addEventListener('input', updateProgress);
    form.addEventListener('change', updateProgress);
    updateProgress();
  }

  if (stepNav) {
    stepNav.querySelectorAll('a[data-devis-step]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('devis-step-' + link.getAttribute('data-devis-step'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (groups.length && 'IntersectionObserver' in window) {
      var navObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var id = entry.target.id;
            var step = id.replace('devis-step-', '');
            stepNav.querySelectorAll('a[data-devis-step]').forEach(function (a) {
              a.classList.toggle('is-active', a.getAttribute('data-devis-step') === step);
            });
          });
        },
        { root: null, rootMargin: '-35% 0px -55% 0px', threshold: 0 }
      );
      groups.forEach(function (g) {
        navObs.observe(g);
      });
    }
  }

  if (sticky && formSection) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === formSection) {
            sticky.hidden = entry.isIntersecting;
          }
        });
      },
      { root: null, threshold: 0.08 }
    );
    observer.observe(formSection);

    var hero = document.querySelector('.lgk-pc-devis-hero');
    if (hero) {
      var heroObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) sticky.hidden = true;
          });
        },
        { threshold: 0.15 }
      );
      heroObs.observe(hero);
    }

    sticky.hidden = true;
  }
})();
